export const Cards = [12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1]
export const Mods = ['x2', 'a2', 'a4', 'a6', 'a8', 'a10'] as const
export const PointsToWin = 200

export type Card = number | (typeof Mods)[number]
